import React from "react";
import { twMerge } from "tailwind-merge";
import { Badge, BadgeProps } from "./Badge";

export const OrderAcceptedBadge = (props: BadgeProps): React.ReactElement => (
  <Badge
    {...props}
    icon={"THUMB_UP_OUTLINE"}
    className={twMerge("bg-orange-100 text-orange-800", props.className)}
  >
    Order accepted
  </Badge>
);
